module.exports = __webpack_public_path__ + "img/jiGuang1.71bd9c86.png";